import { Component, OnInit } from '@angular/core';

import { MembershipService } from '../../../../../../services/membership/membership.service';
import { EntryPassService } from '../../../../../../services/entry-pass/entry-pass.service';
import { VoucherPackService } from '../../../../../../services/voucher-pack/voucher-pack.service';
import { MembershipGiftDiscount } from '../../../../../../models/membership';
import { EntryPassGiftDiscount } from '../../../../../../models/entry-pass';
import { VoucherPackGiftDiscount, VoucherPackGiftDiscountType } from '../../../../../../models/voucher-pack';
import { dateStringFromISO8601 } from '../../../../../../utils';
import { EntryPassGiftDiscountType } from '../../../../../../models/entry-pass-enums';
import { OrganizationConfigService } from '../../../../../../services/organization-config/organization-config.service';
import { MembershipGiftDiscountType } from '../../../../../../models/membership-enums';


@Component({
  selector: 'app-gift-discounts',
  templateUrl: './gift-discounts.component.html',
  styleUrls: ['./gift-discounts.component.css']
})
export class GiftDiscountsComponent implements OnInit {
  public membershipGiftDiscountsList: MembershipGiftDiscount[] = null;
  public entryPassGiftDiscountsList: EntryPassGiftDiscount[] = null;
  public voucherPackGiftDiscountsList: VoucherPackGiftDiscount[] = null;

  public loadingMembershipGiftDiscounts = true;
  public loadingEntryPassGiftDiscounts = true;
  public loadingVoucherPackGiftDiscounts = true;

  public serverError: number = null;

  // Make browser history available to the template.
  public history: History;

  public readonly dateStringFromISO8601 = dateStringFromISO8601;
  public readonly MembershipGiftDiscountType = MembershipGiftDiscountType;
  public readonly EntryPassGiftDiscountType = EntryPassGiftDiscountType;
  public readonly VoucherPackGiftDiscountType = VoucherPackGiftDiscountType;

  constructor(
    public orgConfig: OrganizationConfigService,
    private membershipService: MembershipService,
    private entryPassService: EntryPassService,
    private voucherPackService: VoucherPackService,
  ) {}

  ngOnInit() {
    // Make browser history available to the template.
    this.history = history;

    this.loadMembershipGiftDiscounts();
    this.loadEntryPassGiftDiscounts();
    this.loadVoucherPackGiftDiscounts();
  }

  public membershipGiftDiscountResultsPresent() {
    return (
      (this.membershipGiftDiscountsList !== null) &&
      (this.membershipGiftDiscountsList.length >  0)
    );
  }

  public entryPassGiftDiscountResultsPresent() {
    return (
      (this.entryPassGiftDiscountsList !== null) &&
      (this.entryPassGiftDiscountsList.length >  0)
    );
  }

  public voucherPackGiftDiscountResultsPresent() {
    return (
      (this.voucherPackGiftDiscountsList !== null) &&
      (this.voucherPackGiftDiscountsList.length >  0)
    );
  }

  private loadMembershipGiftDiscounts() {
    this.loadingMembershipGiftDiscounts = true;

    this.membershipService
      .getMembershipGiftDiscounts(1, 3000, {})
      .then(response => {
        this.membershipGiftDiscountsList = response.results;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => {
        this.loadingMembershipGiftDiscounts = false;
      });
  }

  private loadEntryPassGiftDiscounts() {
    this.loadingEntryPassGiftDiscounts = true;

    this.entryPassService
      .getEntryPassGiftDiscounts(1, 3000, {})
      .then(response => {
        this.entryPassGiftDiscountsList = response.results;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => {
        this.loadingEntryPassGiftDiscounts = false;
      });
  }

  private loadVoucherPackGiftDiscounts() {
    this.loadingVoucherPackGiftDiscounts = true;

    this.voucherPackService
      .getVoucherPackGiftDiscounts(1, 3000, {})
      .then(response => {
        this.voucherPackGiftDiscountsList = response.results;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => {
        this.loadingVoucherPackGiftDiscounts = false;
      });
  }
}
